// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.4930394,2.14109838 C11.9545068,2.14109838 14.7705033,4.86243443 14.7705033,8.2075438 C14.7705033,11.5526532 11.9545068,14.2739892 8.4930394,14.2739892 C5.03157195,14.2739892 2.2155755,11.5526532 2.2155755,8.2075438 C2.2155755,4.86243443 5.03157195,2.14109838 8.4930394,2.14109838 M14.9935379,13.4839239 C16.2807873,12.0051386 16.9860788,10.1445241 16.9860788,8.2075438 C16.9860788,3.68197552 13.1760275,0 8.4930394,0 C3.81005133,0 0,3.68197552 0,8.2075438 C0,12.7331121 3.81005133,16.4150876 8.4930394,16.4150876 C10.2510986,16.4150876 11.9264429,15.9026514 13.3588125,14.929879 L18.4033086,20 L20,18.515862 L14.9935379,13.4839239 Z"
            />
        </svg>
    );
};

export default React.memo(Search);
